export function beginNutritionPlanOptionPillEdit({
  option = null,
  onSelect = null,
  onStartEditing = null,
  preserveSelection = true,
} = {}) {
  const optionId = String(option?.id ?? "").trim();
  const currentName = typeof option?.name === "string" ? option.name : "";

  if (!preserveSelection && optionId) {
    onSelect?.(optionId);
  }

  if (optionId) {
    onStartEditing?.(optionId);
  }

  return {
    currentName,
    draftValue: currentName,
    shouldSkipNextCommit: false,
    shouldSkipNextBlurCommit: false,
  };
}
